import React, { useState } from 'react';
import { Globe } from 'lucide-react';
import { useLang } from '../i18n/LangContext';
import { LANGS } from '../i18n/dictionary';

export const LanguageSwitcher = ({ className = '' }) => {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  return (
    <div className={`inline-flex items-center gap-1 rounded-full border border-slate-700 bg-slate-900/80 p-0.5 backdrop-blur ${className}`} data-testid="language-switcher" title="Idioma / Language">
      <button onClick={() => setOpen(!open)} data-testid="lang-toggle-btn" aria-label="Idioma" className="flex items-center gap-1 rounded-full px-1.5 py-0.5 text-[11px] font-semibold text-slate-300 md:pointer-events-none">
        <Globe className="h-3.5 w-3.5 text-slate-400" /><span className="md:hidden">{lang.toUpperCase()}</span>
      </button>
      {LANGS.map(([code, short, name]) => (
        <button key={code} onClick={() => { setLang(code); setOpen(false); }} aria-label={name} data-testid={`lang-${code}-btn`}
          className={`${open ? 'inline-block' : 'hidden'} md:inline-block rounded-full px-2 py-0.5 text-[11px] font-semibold transition-colors ${lang === code ? 'bg-blue-600 text-white' : 'text-slate-400 hover:text-white'}`}>
          {short}
        </button>
      ))}
    </div>
  );
};
